import React from 'react';
import { useTranslation } from 'react-i18next';

import { TOPICAL_PATH } from '../../../config/constants';
import Button from '../../Button';

interface RelatedContentMoreButtonProps {
  url?: string;
}

const RelatedContentMoreButton: React.FC<RelatedContentMoreButtonProps> = (props) => {
  const {
    url = TOPICAL_PATH,
  } = props;

  const { t } = useTranslation();

  return (
    <Button
      className="RelatedContent__read-more"
      type="secondary"
      icon="chevron_right"
      href={url}
    >
      {t('components.related_content.more')}
    </Button>
  );
};

export default RelatedContentMoreButton;
